import { useEffect, useState } from "react";
import { useAuthValue } from 'context/AuthContext';
import useOffCanvasReducer from "hooks/useOffCanvasReducer";
import { loadLaravelUser } from "utils/helpers";
import useLocalStorage from "hooks/useLocalStorage";
import axios from "axios";

export function useHomeAgent() {
    const [buildings, setBuildings] = useState();
    const [showOffCanvasAddBuilding, setShowOffCanvasAddBuilding] = useState(false);
    const [showOffCanvasAddFunds, dispatchShowOffCanvasAddFunds] = useOffCanvasReducer();
    const [showOffCanvasHistoryFunds, dispatchShowOffCanvasHistoryFunds] = useOffCanvasReducer();
    const { setUser, user } = useAuthValue();

    useEffect(() => {
        loadLaravelUser().then(u => setUser(u));
    }, []);

    useEffect(() => {
        if (buildings || !user) return;
        axios.get('buildings', {
            params: {
                organization_id: user.agent?.getSelectedOrganization().id,
                status: 'NEVER_RESERVED',
                limit: 5
            }
        })
        .then(res => {
            setBuildings(res.data);
        });
    }, [buildings, user]);

    return {
        showOffCanvasAddBuilding, setShowOffCanvasAddBuilding,
        showOffCanvasAddFunds, dispatchShowOffCanvasAddFunds,
        showOffCanvasHistoryFunds, dispatchShowOffCanvasHistoryFunds,
        buildings
    }
}

export function useHome() {

    const [showRequestNotifications, dispatchShowRequestNotifications] = useOffCanvasReducer();
    const [notificationDenied] = useLocalStorage('notification_permission_denied');
    const { user, notification } = useAuthValue();
    const { notificationPermission } = notification;

    useEffect(() => {
        setTimeout(() => {
            if (notificationPermission !== null || notificationDenied === true) return;
            dispatchShowRequestNotifications('OPEN');
        }, 1000);
    }, [notificationPermission]);

    return {
        user,
        showRequestNotifications, dispatchShowRequestNotifications
    }

}